<template>
  <div class="sidebar-container" :class="[isCollapse ? 'hide-side-bar':'']">
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <div class="slide-bar">
        <div class="nav-header">
          <div v-show="!isCollapse" class="logo-txt">5G云后台管理系统</div>
        </div>
        <div class="slide-toggle">
          <i @click="isCollapse = !isCollapse" class="iconfont"
             :class="[isCollapse ? 'icon-expansion' : 'icon-fold']"></i>
        </div>
        <el-menu
            mode="vertical"
            :background-color="variables.menuBg"
            :text-color="variables.menuText"
            :active-text-color="variables.menuActiveText"
            :default-active="activeMenu"
            :unique-opened="true"
            :collapse-transition="false"
            :collapse="isCollapse"

        >
          <sidebar-item v-for="route in permission_routes" :key="route.path" :item="route" :base-path="route.path"/>
        </el-menu>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import SidebarItem from './SidebarItem'
  import variables from '@/styles/variables.scss'

  export default {
    components: {SidebarItem},
    data() {
      return {
        isCollapse: false
      }
    },
    watch: {
      isCollapse() {
        this.$emit('collapseChnage', this.isCollapse);
      }
    },
    computed: {
      ...mapGetters([
        'permission_routes'
      ]),
      activeMenu() {
        const route = this.$route
        const {meta, path} = route
        if (meta.activeMenu) {
          return meta.activeMenu
        }
        return path
      },
      variables() {
        return variables
      }
    },
    created() {
    }
  }
</script>

<style lang="scss" scoped>
  .slide-bar {
    height: 100%;
    background: #2f4050;
  }

  .nav-header {
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: #c1cbd7;
    font-size: 12px;
    border-bottom: 1px solid #424242;
  }

  .slide-toggle {
    text-align: center;
    color: #a7b1c2;
    background: #293948;
    line-height: 44px;
    border-bottom: 1px solid #424242;
  }

  .slide-toggle .iconfont {
    cursor: pointer;
  }
</style>

<style lang="scss">
  @import "src/styles/variables";

  .sidebar-container {
    width: $sideBarWidth;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    transition: width .3s ease;
    &.hide-side-bar {
      width: $sideBarMiniWidth;
      .el-menu--collapse .el-submenu > .el-submenu__title > span {
        height: 0;
        width: 0;
        overflow: hidden;
        visibility: hidden;
        display: inline-block;
      }
    }
    .el-scrollbar {
      height: 100%;
    }
    .scrollbar-wrapper {
      height: 100%;
    }
    .el-scrollbar__view {
      width: 100%;
      height: 100%;
    }
    .el-menu {
      width: 100% !important;
    }
  }

  .slide-bar {
    .el-menu {
      border: 0;
    }
    .el-menu-item {
      font-size: 12px;
      min-width: initial;
    }
    .el-submenu__title {
      font-size: 12px;
    }
    .el-submenu [class^=el-icon-] {
      font-size: 16px;
    }
    .el-submenu .el-menu-item, .nest-menu .el-submenu > .el-submenu__title {
      background: $subMenuBg !important;
      &:hover {
        background: $subMenuHover !important
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/components/SideBar/SideBar.vue